import { Linker } from '@/components/content/linker'
import { HiLocationMarker as LocationIcon } from "react-icons/hi";
import { FaMapMarkedAlt as MapIcon } from "react-icons/fa";


export function EventLocation({ location }) {
  // console.log({location})
  return (
    <div>
      <span className="block mb-4 text-sm font-medium tracking-widest text-gray-600 uppercase"> <LocationIcon className="inline-block" /> Location </span>
      {location?.organization && <p className="mb-1 text-base font-semibold text-gray-600">{location?.organization}</p>}
      {location?.address && <p className="mb-1 text-base text-gray-600">{location?.address}</p>}
      {(location?.city || location?.state || location?.zip) &&
        <p className="mb-1 text-base text-gray-600">{location?.city} {location?.state} {location?.zip}</p>}

      {(location?.geoLocation?.lat && location?.geoLocation?.lng) && (
        <p className="flex items-center mb-2 space-x-2 text-base text-gray-600"><MapIcon /> <Linker url={`https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination=${location?.geoLocation?.lat},${location?.geoLocation?.lng}`} classes="hover:underline">Map and Directions</Linker></p>
      )}
    </div>
  );
}



